<div>
  <app-upload-file (fileChange)="onFileChange($event)" accept="application/xml"></app-upload-file>
</div>
